<!-- Base.SearchForm.vue (client) -->
<template tag="클라이언트 검색 폼 컴포넌트">
  <div class="search_input">
    <Base.Input
      v-model="model"
      type="search"
      :placeholder="placeholder"
      @keyup.enter="onClickHandleSearch"
    />
    <Base.Button icon="btn_search" txt="none" @click="onClickHandleSearch">
      {{ $text("button.search") }}
    </Base.Button>
  </div>
</template>

<script setup lang="ts">
import { Base } from "@/common/base-components/BaseFactory.ts";

/* ------------------------------------------------------------
                          Vue Instance & Global Properties
   ------------------------------------------------------------ */
import { i18n } from "@/app/plugins/global";
const { $text } = i18n();

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel<string>({ required: true });

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps({
  placeholder: {
    type: String,
    default: "",
  },
  onSearch: {
    type: Function,
    required: false,
    default: () => {},
  },
});

/* ------------------------------------------------------------
                          Variable Declarations
   ------------------------------------------------------------ */
/** 기본값 적용 */
const placeholder = props.placeholder ?? $text("message.searchPlaceholder");

/* ------------------------------------------------------------
                                  Methods
   ------------------------------------------------------------ */
/** ko: 검색 처리 en: handle search */
const onClickHandleSearch = () => {
  props.onSearch?.(model.value);
};
</script>
